import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { Helmet } from 'react-helmet';
import Routes from './Routes';

function App() {
  return (
    <div className="App">
      <Helmet>
        <title>Nia | Dance Fitness for the Mind, Body and Soul</title>
        <meta name="description" content="Nia is a holistic movement & wellness practice. Our dance fitness classes and trainings emphasize somatic movement for the mind, body, and soul." />
        <meta name="keywords" content="dance, fitness, classes, somatic, movement" />
      </Helmet>
      <CssBaseline />
      <Routes />
    </div>
  );
}

export default App;
